"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classnames = require("classnames");
exports.withAutogrow = function (Component) {
    return /** @class */ (function (_super) {
        __extends(WithAutogrow, _super);
        function WithAutogrow() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            /* istanbul ignore next */
            _this._autogrow = function () {
                var ref = _this._textarea;
                ref.style.height = 'auto';
                ref.style.height = ref.scrollHeight + "px";
            };
            _this._onChange = function (e) {
                var _a = _this.props, autogrow = _a.autogrow, onChange = _a.onChange;
                /* istanbul ignore else */
                if (onChange) {
                    onChange(e);
                }
                /* istanbul ignore next */
                if (autogrow) {
                    _this._autogrow();
                }
            };
            _this._ref = function (ref) {
                var textareaRef = _this.props.textareaRef;
                if (textareaRef) {
                    textareaRef(ref);
                }
                _this._textarea = ref;
            };
            return _this;
        }
        WithAutogrow.prototype.render = function () {
            var _a = this.props, autogrow = _a.autogrow, className = _a.className, rest = __rest(_a, ["autogrow", "className"]);
            var classNames = classnames('autogrow', className);
            return React.createElement(Component, __assign({}, rest, { className: classNames, textareaRef: this._ref, onChange: this._onChange }));
        };
        return WithAutogrow;
    }(React.PureComponent));
};
exports.default = exports.withAutogrow;
//# sourceMappingURL=withAutogrow.js.map


//////////////////
// WEBPACK FOOTER
// ../@csod/textbox/build/control/hocs/textarea/withAutogrow.js
// module id = 326
// module chunks = 0 1